import { GetStaticPropsContext, NextPageContext } from 'next'
import { Store } from 'redux'
import {
  institutionItemSelectors,
  institutionItemThunks,
} from '@ucheba/store/institutions/item'
import { divisionsSelector, divisionsThunk } from '@ucheba/store/institutions/divisions'
import { FACETS_NAMES } from '@ucheba/store/institutions/divisions/constants'
import { headerActions } from '../../../components/Header/store'

type GetInstitutionUnitsPageProps = {
  ctx: NextPageContext | GetStaticPropsContext
  store: Store
}

type GetInstitutionUnitsPageReturn = Promise<{
  notFound?: boolean
  content?: {
    seo: {
      meta: {
        title: string
        description: string
        keywords: string
      }
    }
  }
}>

export const getInstitutionUnitsPageProps = async (
  props: GetInstitutionUnitsPageProps
): Promise<GetInstitutionUnitsPageReturn> => {
  const { ctx, store } = props
  const query = (ctx as GetStaticPropsContext).params || (ctx as NextPageContext).query
  const { dispatch, getState } = store

  const id = query?.id

  let institution = institutionItemSelectors.currentInstitution(getState())

  if (!institution || String(institution?.id) !== id) {
    await dispatch<any>(institutionItemThunks.fetchInstitution({ data: { id } }))
  }

  institution = institutionItemSelectors.currentInstitution(getState())

  if (!institution) {
    return {
      notFound: true,
    }
  }
  const { abbreviation, name, keywords, hasSubdivisions } = institution

  if (!hasSubdivisions) {
    return {
      notFound: true,
    }
  }

  await dispatch<any>(
    divisionsThunk.fetchDivisionsFacest({ data: { institutionId: id } })
  )

  const facets = divisionsSelector.facets(getState())

  const queryType = query?.type as string

  const currentTypeValue = Object.keys(FACETS_NAMES).find(
    (key) => FACETS_NAMES[key] === queryType
  )

  const parentTypeId = currentTypeValue || Number(facets?.[0]?.value)

  if (hasSubdivisions) {
    await dispatch<any>(
      divisionsThunk.fetchDivisions({
        data: {
          institutionId: query.id,
          parentTypeId,
          limit: 15,
          offset: Number(query.page) > 1 ? (Number(query.page) - 1) * 15 : 0,
        },
      })
    )
  }

  dispatch(headerActions.toggleHeader(true))

  return {
    content: {
      seo: {
        meta: {
          title: `Факультеты и филиалы — ${abbreviation || name}`,
          description: `Информация о факультетах, филилах и других подразделениях — ${name}`,
          keywords,
        },
      },
    },
  }
}
